import { render, staticRenderFns } from "./ItemBadges.vue?vue&type=template&id=e0464036&scoped=true&"
import script from "./ItemBadges.vue?vue&type=script&lang=js&"
export * from "./ItemBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0464036",
  null
  
)

export default component.exports